package com.rainbowclubs.rainbow.domain.use_cases.membership

import com.rainbowclubs.rainbow.data.models.Membership
import com.rainbowclubs.rainbow.domain.repositories.MembershipRepository

class GetPendingMembershipsUseCase(
    private val membershipRepository: MembershipRepository,
) {
    suspend operator fun invoke(clubId: String): Result<List<Membership>> {
        return membershipRepository.getPendingMemberships(clubId)
    }
}
